var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCounter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 36C33.8825 36 28.5 30.6175 28.5 24C28.5 17.3825 33.8825 12 40.5 12C47.1175 12 52.5 17.3825 52.5 24C52.5 30.6175 47.1175 36 40.5 36ZM40.5 18C37.1925 18 34.5 20.6925 34.5 24C34.5 27.3075 37.1925 30 40.5 30C43.8075 30 46.5 27.3075 46.5 24C46.5 20.6925 43.8075 18 40.5 18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 69H12C12 53.285 24.785 40.5 40.5 40.5C49.58 40.5 58.195 44.8875 63.5475 52.2325L58.6975 55.765C54.47 49.9625 47.6675 46.4975 40.4975 46.4975C28.09 46.4975 17.9975 56.59 17.9975 68.9975L18 69Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.457 99H96V93H102V78C102 71.16 96.82 66 89.9525 66H55.6275C53.075 66 51 68.115 51 70.715V93H60V99H45V70.715C45 64.8075 49.7675 60 55.6275 60H89.9525C100.073 60 108 67.9075 108 78V93.525C108 96.545 105.512 99 102.457 99Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84 93H69V99H84V93Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105C85.0375 105 81 100.963 81 96C81 91.0375 85.0375 87 90 87C94.9625 87 99 91.0375 99 96C99 100.963 94.9625 105 90 105ZM90 93C88.345 93 87 94.345 87 96C87 97.655 88.345 99 90 99C91.655 99 93 97.655 93 96C93 94.345 91.655 93 90 93Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105C58.0375 105 54 100.963 54 96C54 91.0375 58.0375 87 63 87C67.9625 87 72 91.0375 72 96C72 100.963 67.9625 105 63 105ZM63 93C61.345 93 60 94.345 60 96C60 97.655 61.345 99 63 99C64.655 99 66 97.655 66 96C66 94.345 64.655 93 63 93Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90 72H87C85.3431 72 84 73.3431 84 75V78C84 79.6569 85.3431 81 87 81H90C91.6569 81 93 79.6569 93 78V75C93 73.3431 91.6569 72 90 72Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72H60C58.3431 72 57 73.3431 57 75V78C57 79.6569 58.3431 81 60 81H72C73.6569 81 75 79.6569 75 78V75C75 73.3431 73.6569 72 72 72Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter);
export default __webpack_public_path__ + "static/media/Counter.6dc2ab20.svg";
export { ForwardRef as ReactComponent };